<template>
  <div id="page-user-list" >
    <div class="vx-card p-6 ml-2 minus-top">
        <span>{{packageString}}</span>
        <div class="flex">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto"></span>
          </div>
        </div>

        <div class="flex" style="background-color: #f5f5f6">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto header-float" style="font-weight: bold;">{{$t('packageUpgrade.limit')}}</span>
          </div>
        </div>

        <div class="flex">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto header-float">{{$t('packageUpgrade.numberFolow')}}</span>
          </div>
          <div v-for="item in packages" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto">{{item.totalKeyword}} {{$t('packageUpgrade.keyword')}}</span>
          </div>
        </div>

        <div class="flex">
          <div class="flex-1 bg-grid-color-secondary h-12 flex">
            <span class="sm:flex hidden m-auto header-float">{{$t('packageUpgrade.numberSubKey')}}</span>
          </div>
          <div v-for="item in packages" class="flex-1 bg-grid-color-secondary h-12 flex">
            <span class="sm:flex hidden m-auto">{{item.totalSubAccount}} {{$t('packageUpgrade.keyword')}}</span>
          </div>
        </div>

        <div class="flex">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto header-float">{{$t('packageUpgrade.dayUser')}}</span>
          </div>
          <div v-for="item in packages" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto">{{item.days}} {{$t('packageUpgrade.day')}}</span>
          </div>
        </div>

        <div class="flex">
          <div class="flex-1 bg-grid-color-secondary h-12 flex">
            <span class="sm:flex hidden m-auto header-float">{{$t('packageUpgrade.limitData')}}</span>
          </div>
          <div v-for="item in packages" class="flex-1 bg-grid-color-secondary h-12 flex">
            <span class="sm:flex hidden m-auto">{{item.totalData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }}</span>
          </div>
        </div>

        <div class="flex">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto header-float">{{$t('packageUpgrade.createAcc')}}</span>
          </div>
          <div v-for="item in packages" class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto">{{item.allowUserRegister == true ? $t('packageUpgrade.yes') : $t('packageUpgrade.no')}}</span>
          </div>
        </div>

        <!-- <div class="flex">
          <div class="flex-1 bg-grid-color-secondary h-12 flex">
            <span class="sm:flex hidden m-auto header-float">{{$t('packageUpgrade.cost')}}</span>
          </div>
          <div v-for="item in packages" class="flex-1 bg-grid-color-secondary h-12 flex">
              <span class="sm:flex hidden m-auto">{{item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}} {{$t('packageUpgrade.vnd')}}</span>
          </div>
        </div> -->

        <div class="flex mt-3" style="background-color: #f5f5f6">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto header-float" style="font-weight: bold;">{{$t('packageUpgrade.feature')}}</span>
          </div>
        </div>

        <div v-for="(p) in allPermissions">
          <div class="flex">
            <div class="flex-1 h-12 flex">
              <span class="sm:flex hidden m-auto header-float">{{p.functionAlias}}</span>
            </div>
            <div v-for="item in packages" class="flex-1 h-12 flex">
              <span class="sm:flex hidden m-auto">
                <feather-icon v-if="item[p.functionAlias.toString()]" icon="CheckIcon" style="width: 1.2rem;color: green;"></feather-icon>
              </span>
            </div>
          </div>
        </div>

        <div class="flex">
          <div class="flex-1 h-12 flex">
            <span class="sm:flex hidden m-auto header-float"></span>
          </div>
          <div v-for="item in packages" class="flex-1 h-12 flex">
            <div class="sm:flex hidden m-auto">
              <vs-button
                @click="userRegisterPackage(item.id)"
                color="primary"
                type="border">
                {{$t('packageUpgrade.request')}}
              </vs-button>
            </div>
          </div>
        </div>

    </div>
  </div>
</template>

<style>
  .bg-grid-color-secondary {
    background-color: #dae1e729;
  }

  [dir] .m-auto {
    color: #2a3035;
  }

  .header-float {
    margin-left: 10px !important;
  }

  .vx-card__title > h4 {
    font-weight: bold;
  }
</style>

<script>
  import moment from "moment";

  export default {
    components: {},
    data() {
      return {
        packageString: '',
        packages: [],
        allPermissions: [],
        usingPackage: {}
      }
    },
    created() {
      this.initScreen();
    },
    watch: {
      '$store.state.windowWidth'(val) {
        if (val <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (val > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      '$store.state.reduceButton'() {
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 650);
      },
      '$store.state.isUpdateUser'(val) {
        if (val) {
          this.initScreen();
          this.$store.commit('UPDATE_USER_SUCCESS', false);
        }
      },
    },
    computed: {
      totalPages() {
        if (this.gridApi) return this.gridApi.paginationGetTotalPages();
        else return 0
      },
      currentPage: {
        get() {
          if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
          else return 1
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      }
    },
    methods: {
      onGridReady() {
        if (this.$store.state.windowWidth <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (this.$store.state.windowWidth > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      checkRegisterPackage: function(){
        return new Promise((resolve, reject) => {
          this.$business.post('user-package/using-package').then((res) => {
            const result = [res.data];
            if(result.length > 0){
              return this.$vs.dialog({
                type: 'confirm',
                color: 'primary',
                title: this.$t('packageUpgrade.titlePackage'),
                accept: this.backToPackageManage,
                text: `${this.$t('packageUpgrade.text1')} ` + ` ${result[0].businessPackage.name} ` + ` ${this.$t('packageUpgrade.text2')}` ,
                acceptText: this.$t('packageUpgrade.acceptText'),
                cancelText: this.$t('packageUpgrade.cancelText'),
              })
            }
            resolve();
          }).catch(()=>reject())
        })
      },
      async initScreen() {
        this.usingPackage = await this.getUsingPackage(this);
        if (new Date(this.usingPackage.expiredDate).getTime() > new Date()) {
          this.packageString = this.usingPackage.businessPackage.name + ` ${this.$t('packageUpgrade.text3')} ` + moment(this.usingPackage.expiredDate).format("DD/MM/YYYY") + ".";
        } else {
          this.packageString = this.usingPackage.businessPackage.name + ` ${this.$t('packageUpgrade.text4')} `
        }
        this.packages = await this.getPackage(this);
        this.packages = this.packages.filter(item => item.allowUserRegister);
        this.allPermissions = await this.getAllPermission(this);
        this.allPermissions.forEach(permission => {
          let functionAlias = permission.functionAlias;
          this.packages.forEach(p => {
            p[functionAlias.toString()] = "";
            let permissions = p.permissions;
            if (permissions && permissions.length > 0) {
              let per = permissions.find(per => per.id == permission.id);
              if (per) {
                p[functionAlias.toString()] = true;
              } else {
                p[functionAlias.toString()] = false;
              }
            } else {
              p[functionAlias.toString()] = false;
            }
          })
        });
        this.allPermissions = this.allPermissions.sort(function(a,b){
          return parseInt(a.metadata) - parseInt(b.metadata);
        });
      },
      getPackage(that) {
        return new Promise(function (resolve, reject) {
            that.$business.get('/business-package/all').then((res) => {
              resolve(res.data);
            }).catch((err) => {
              reject(err);
            });
          }
        );
      },
      getAllPermission(that) {
        return new Promise(function (resolve, reject) {
            that.$business.post('/permission/all').then((res) => {
              resolve(res.data);
            }).catch((err) => {
              reject(err);
            });
          }
        );
      },
      getUsingPackage(that) {
        return new Promise(function (resolve, reject) {
            that.$business.post('/user-package/using-package').then((res) => {
              resolve(res.data);
            }).catch((err) => {
              reject(err);
            });
          }
        );
      },
      backToPackageManage(){
        this.$router.push('/user/package/manage').catch(() => {});
      },
      userRegisterPackage(id) {
        this.checkRegisterPackage().then(() => {
          this.$business.post('/user-package/register', {packageId: id}).then(() => {
            this.$vs.dialog({
              type: 'confirm',
              color: 'primary',
              title: this.$t('packageUpgrade.titleSuccess'),
              accept: this.backToPackageManage,
              text: this.$t('packageUpgrade.text5'),
              acceptText: this.$t('packageUpgrade.acceptText'),
              cancelText: this.$t('packageUpgrade.cancelText'),
            })
          }).catch((err) => {
            this.$vs.loading.close();
            return this.$vs.notify({
              text: err.response.message || err.response.error_description || err.data.error,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          });
        });
      }
    },
    mounted() {
    }
  }
</script>
<style scoped>
.minus-top{
  margin-top: -24px;
}
@media (max-width: 1366px){
#page-user-list{
  margin-left: -13px;
}
}
</style>
